import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './type';

const reducers = {
  setRegisteredUser: (state: IRootState, action: PayloadAction<IRootState['registeredUser']>) => ({
    ...state,
    registeredUser: action.payload,
  }),
  setIsOpenPricingNav: (state: IRootState, action: PayloadAction<IRootState['isOpenPricingNav']>) => ({
    ...state,
    isOpenPricingNav: action.payload,
  }),
  setInviteMembers: (state: IRootState, action: PayloadAction<IRootState['inviteMembers']>) => ({
    ...state,
    inviteMembers: action.payload,
  }),
};

export {
  reducers,
};
